import "./RecommendationCard.scss";
import calendar from "../../assets/icons/calendar-check.svg";
import { defaultSrImg } from "../../utils/helper";
import arrow from "../../assets/icons/arrow.svg";

const RecommendationCard = ({ rec, subreddits, kw }) => {
  if (kw) {
    subreddits = subreddits.find((sr) => sr.name === rec[0].toLowerCase());
    if (!subreddits) {
      subreddits = { icon: defaultSrImg };
    } else if (subreddits.icon === "" || subreddits.icon === null) {
      subreddits.icon = defaultSrImg;
    }
  }

  return (
    <article className="card">
      <div className="card__container">
        <img
          src={kw ? subreddits.icon : calendar}
          alt={kw ? `subreddit icon` : "Calendar"}
          className={`card__img ${kw ? "" : "card__img--blue"}`}
        />
        <h3 className="card__title">
          {rec.dayOfWeek
            ? `${rec.dayOfWeek} ${rec.timeOfDay}`
            : `${rec[0][0].toUpperCase()}${rec[0].slice(1)}`}
        </h3>
      </div>
      <div className="card__container-bottom">
        <p className="card__text">
          {rec.dayOfWeek ? "Schedule a post" : "Subreddit Analysis"}
        </p>
        <img src={arrow} alt="arrow icon" className="card__arrow" />
      </div>
    </article>
  );
};

export default RecommendationCard;
